import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { User } from "../../types/user";
import { api } from "./index.api";
import { StatusCodes } from "http-status-codes";
import toastError from "../../components/notif";

function authApiErrorHandler(err: FetchBaseQueryError) {
  switch (err.status) {
    case StatusCodes.FORBIDDEN:
      return toastError("Only Admin Access");
    case StatusCodes.UNAUTHORIZED:
      return toastError("Invali Phone or Password");
    default:
      return toastError("Unknown Error Please try again later");
  }
}

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<
      {user:User},
      {
        phone: string;
        password: string;
      }
    >({
      query: (input) => ({
        url: "/admin/auth/login",
        method: "POST",
        body: input,
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          authApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
    }),
  }),
  overrideExisting: true,
});

export const { useLoginMutation } = authApi;
